import defaults from './default.service';

export const statisticsService = {
  get_statistics,
};

function get_statistics() {
  const requestOptions = {
    ...defaults.defaultRequestOptions('GET'),
  };
  return defaults.defaultFetch({
    url: `/admin/get_statistics`,
    requestOptions,
  });
}
